<template>
  <div class="yzm-timeselect" :style="{ ...marginStyle }">
    <el-date-picker
      v-model="value"
      :default-value="item.timeValue"
      type="date"
      placeholder="请选择日期"
      format="YYYY/MM/DD"
      value-format="x"
      v-if="item.setting?.timeType * 1 === 1"
    />
    <el-date-picker
      v-model="value"
      type="datetime"
      placeholder="请选择日期时间"
      format="YYYY/MM/DD HH:mm:ss"
      value-format="x"
      v-if="item.setting?.timeType * 1 === 2"
    />
    <el-time-picker
      v-model="value"
      :default-value="item.timeValue"
      format="HH:mm:ss"
      placeholder="请选择时间"
      v-if="item.setting?.timeType * 1 === 3"
    />
  </div>
</template>
<script setup>
import { defineProps, computed, ref, watch, onMounted, defineEmits } from 'vue'
import { defaultProps } from './defaultProps'
const props = defineProps({
  ...defaultProps,
  isMargin: { type: Boolean, default: true }
})
const value = ref(null)
watch(
  () => props.item,
  (newVal) => {
    value.value = newVal?.setting?.timeValue || null
  },
  { immediate: true }
)
const timeStyle = computed(() => {
  let item = props.item.setting
  return {
    color: item.color,
    textAlign: item.textAlign
  }
})
const marginStyle = computed(() => {
  if (!props.isMargin) return {}
  let item = props.item.setting
  return {
    marginTop: `${item.marginTop}px`,
    marginBottom: `${item.marginBottom}px`,
    marginLeft: `${item.marginLeft}px`,
    marginRight: `${item.marginRight}px`
  }
})
const emit = defineEmits(['childMounted'])
onMounted(() => {
  emit('childMounted')
})
</script>
<style lang="less" scoped>
.yzm-timeselect {
  :deep(.el-input__wrapper) {
    width: 100%;
  }
  :deep(.el-input) {
    width: 100%;
  }
}
</style>
